module.exports = __webpack_public_path__ + "img/image 29.9920fdda.png";